









import hash from 'object-hash';
import { listFactory } from '@/main/pages';
import { convertToObjects } from '@/main/utils/table';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import Save from '#components/dms/button/Save.vue';

import { NAME, COLUMN_POZNAMKA, COLUMN_CHECKBOX } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	components: {
		DmsEditableTable,
		'dms-save': Save,
	},
	data() {
		return {
			schemaSettings: {
				isEditable: true,
				columns: {
					[COLUMN_POZNAMKA]: { isEditable: true },
					[COLUMN_CHECKBOX]: { isEditable: true },
				},
			},
		};
	},
	computed: {
		isModified(): boolean {
			return this.table.hash !== hash(this.table.rows);
		},
		saveDisabled(): boolean {
			return this.loading;
		},
	},
	methods: {
		async handleSave() {
			try {
				this.startLoading();
				await apiProvider.updateList(convertToObjects(this.table));
			} finally {
				this.table.hash = hash(this.table.rows);
				this.endLoading();
			}
		},
	},
});
